<script setup lang="ts">
import { $isListNode } from "@lexical/list";
import { $convertFromMarkdownString } from "@lexical/markdown";
import { $getRoot, $isElementNode, SKIP_DOM_SELECTION_TAG, type SerializedLexicalNode } from "lexical";
import { useLexicalComposer } from "lexical-vue";

import { $createAiCursorNode } from "../nodes/AiCursorNode";
import { TRANSFORMERS } from "../transformers";

const editor = useLexicalComposer();

const getSerializedNodes = (): SerializedLexicalNode[] => editor.getEditorState().toJSON().root.children;

const updateFromMarkdown = (markdown: string, showAiCursor = false) => {
  editor.update(
    () => {
      const root = $getRoot();
      $convertFromMarkdownString(markdown, TRANSFORMERS);

      if (!showAiCursor) {
        return;
      }
      const lastChild = root.getLastChild();
      const targetNode = $isListNode(lastChild) ? lastChild.getLastChild() : lastChild;
      if (targetNode && $isElementNode(targetNode)) {
        targetNode.append($createAiCursorNode());
      }
    },
    { discrete: true, tag: SKIP_DOM_SELECTION_TAG }
  );
};

defineExpose({
  getSerializedNodes,
  updateFromMarkdown,
});
</script>

<template>
  <slot />
</template>
